import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { MaskedTextBoxModule } from "@syncfusion/ej2-angular-inputs";
import {
  ColumnChooserService,
  FilterService,
  GridModule,
  PageService,
  ResizeService,
  SortService,
} from "@syncfusion/ej2-angular-grids";
import { CaseManagerComponent } from "./case-manager.component";
import { CaseManagerRoutingModule } from "./case-manager-routing.module";
import { casemanagerHTTPService } from "./case-manager.service";
import { GetHTTPService } from "./case-table.service";
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    CaseManagerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    CaseManagerRoutingModule,
    NgSelectModule
  ],
  exports:[CaseManagerComponent],
  providers: [casemanagerHTTPService,ColumnChooserService,PageService,SortService,FilterService, ResizeService,GetHTTPService],
})
export class CaseManagerModule { }
